import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  name: 'dev',
  production: false,
  logging: {
    enabled: true,
  },
  okta: {
    issuer: 'https://isg-one.okta.com/oauth2/default',
    clientId: '0oa1yf0vhrz4OzcAo358',
    redirectPath: '/login/callback',
  },
  endpoints: {
    serviceNow: 'https://gx-dev4-wrapper-api-dev-dhgbe8f6f8afcngq.westeurope-01.azurewebsites.net',
    cockpitSummary: 'https://gx-dev4-wrapper-api-dev-dhgbe8f6f8afcngq.westeurope-01.azurewebsites.net'
  },
  engagementMessenger: {
    moduleId: '',
    clientName: 'Dev4',
  },
  oktaAuth: {
    basicToken: '', 
    username: '',
    password: '',
  }
};
